<app-data-selector
  label="Balança Padrão"
  [repository]="weighingMachineRepository"
  display="weighingMachineNameHub"
  [value]="defaultWeighingMachine"
  (valueChange)="onWeighingMachineSelected($event)"
></app-data-selector>
